import React, { useRef, useState, useEffect } from "react";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import MessageIcon from '@mui/icons-material/Message';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import ISChangePassword from '../../changePassword';
import useMessages from '../../hooks/header/useMessages';

const headerStyles = `
  .ish-topbar {
    background: #fff;
    box-shadow: 0 2px 8px rgba(0,0,0,0.10);
    display: flex;
    align-items: center;
    position: relative;
    z-index: 300;
  }

  .ish-topbar .container-fluid { width: 100%; }

  .ish-logo {
    width: 100%;
    object-fit: contain;
  }

  .ish-controls-group {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    flex-wrap: nowrap;
  }

  .ish-mobile-menu-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
    border: 1px solid rgba(0,0,0,0.12);
    border-radius: 8px;
    width: 36px;
    height: 36px;
    cursor: pointer;
    color: #581f37;
    flex-shrink: 0;
    transition: background 0.2s;
  }
  .ish-mobile-menu-btn:hover { background: #f5eaf0; }

  .ish-profile-wrap {
    position: relative;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
  }
  .ish-profile-icon {
    font-size: 2rem !important;
    color: #581f37;
    flex-shrink: 0;
  }

  .ish-username-block {
    flex-direction: column;
    align-items: flex-end;
    line-height: 1.2;
    white-space: nowrap;
  }
  .ish-username-text   { font-size: 13px; font-weight: 600; color: #333; }
  .ish-datetime-badge  {
    font-size: 11px; background: #581f37; color: #fff;
    border-radius: 4px; padding: 1px 6px; margin-top: 2px; display: inline-block;
  }

  .ish-profile-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    min-width: 175px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.12);
    z-index: 1050;
    padding: 6px 0;
    animation: ishDropdownFade 0.15s ease;
  }
  @keyframes ishDropdownFade {
    from { opacity: 0; transform: translateY(-4px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .ish-dropdown-item {
    display: flex; align-items: center; gap: 8px;
    padding: 9px 16px; font-size: 13.5px; color: #333;
    cursor: pointer; transition: background 0.15s; white-space: nowrap;
  }
  .ish-dropdown-item:hover { background: #f5f5f5; color: #581f37; }
  .ish-dropdown-divider    { height: 1px; background: #ececec; margin: 4px 0; }

  .ish-sidebar-toggle-btn {
    background: none; border: none; cursor: pointer;
    padding: 6px; border-radius: 6px; color: #581f37;
    display: flex; align-items: center; justify-content: center;
    transition: background 0.15s; flex-shrink: 0;
  }
  .ish-sidebar-toggle-btn:hover { background: #f5eaf0; }
  .ish-sidebar-toggle-svg .ish-icon-sidebar-open  { display: block; }
  .ish-sidebar-toggle-svg .ish-icon-sidebar-close { display: none;  }
  .ish-sidebar-toggle-btn.on .ish-sidebar-toggle-svg .ish-icon-sidebar-open  { display: none;  }
  .ish-sidebar-toggle-btn.on .ish-sidebar-toggle-svg .ish-icon-sidebar-close { display: block; }

  .ish-message-wrap {
    position: relative; display: flex;
    align-items: center; cursor: pointer; flex-shrink: 0;
  }
  .ish-message-icon { font-size: 1.7rem !important; color: #581f37; }
  .ish-message-badge {
    position: absolute; top: -4px; right: -6px;
    background: #dc3545; color: #fff; font-size: 10px; font-weight: 700;
    border-radius: 50%; min-width: 17px; height: 17px;
    display: flex; align-items: center; justify-content: center;
    padding: 0 3px; pointer-events: none;
  }

  .ish-messages-panel {
    position: absolute; top: calc(100% + 8px); right: 0;
    width: 334px; background: #fff; border: 1px solid #e0e0e0;
    border-radius: 10px; box-shadow: 0 6px 24px rgba(0,0,0,0.13);
    z-index: 1050; max-height: 400px;
    display: flex; flex-direction: column;
    animation: ishDropdownFade 0.15s ease; overflow: hidden;
  }
  
  .ish-messages-panel.ish-messages-panel-mobile {
    position: fixed;
    top: 60px;
    left: 12px;
    right: 12px;
    width: auto;
    }

  .ish-messages-panel-title {
    font-size: 14px; font-weight: 700; color: #fff;
    background: #581f37; padding: 10px 16px;
    border-radius: 10px 10px 0 0; letter-spacing: 0.3px; flex-shrink: 0;
  }
  .ish-messages-list {
    list-style: none; margin: 0; padding: 10px 14px; overflow-y: auto; flex: 1;
  }
  .ish-messages-list::-webkit-scrollbar       { width: 5px; }
  .ish-messages-list::-webkit-scrollbar-track { background: #f1f1f1; }
  .ish-messages-list::-webkit-scrollbar-thumb { background: #ccc; border-radius: 4px; }
  .ish-message-item {
    border-left: 3px solid #581f37; padding: 7px 10px; margin-bottom: 8px;
    border-radius: 0 6px 6px 0; background: #faf5f7; transition: background 0.15s;
  }
  .ish-message-item:hover { background: #f3e9ed; }
  .ish-message-item p {
    margin: 0; font-size: 13px; color: #333; cursor: pointer;
    text-align: left; display: flex; align-items: center; gap: 6px; flex-wrap: wrap;
  }
  .ish-badge-new {
    font-size: 10px; background: #e2e3e5; color: #41464b;
    border-radius: 4px; padding: 1px 6px; font-weight: 600;
  }

  .ish-modal-body      { padding: 16px; }
  .ish-modal-icon-wrap { margin-bottom: 8px; }
  .ish-modal-text      { color: #000; margin-bottom: 0; font-size: 14.5px; line-height: 1.6; }
`;

function Header({
    logo,
    handleLogout,
    toggleFullscreen,
    setToggleFullscreen,
    sidebarOpen,
    setSidebarOpen,
}) {
    const changePasswordRef = useRef();
    const dropdownRef = useRef(null);

    const [showPopup, setShowPopup] = useState(false);
    const [showMessagesPopup, setShowMessagesPopup] = useState(false);
    const [time, setTime] = useState(new Date());
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const {
        messages, count, notiSubject, notiMessage,
        showModal, fetchMessages, handleModalClose, handleViewModalOpen,
    } = useMessages();

    useEffect(() => {
        const onResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, []);

    useEffect(() => {
        const fetchTime = async () => {
            try {
                const res = await fetch("https://ugpapi.mgu.ac.in/api/College/getServerTime");
                if (res.ok) setTime(new Date((await res.json()).server_time));
            } catch (e) { console.error(e); }
        };
        fetchTime();
        const tick = setInterval(() => setTime(p => p ? new Date(p.getTime() + 1000) : null), 1000);
        const onVisible = () => { if (document.visibilityState === "visible") fetchTime(); };
        document.addEventListener("visibilitychange", onVisible);
        return () => { clearInterval(tick); document.removeEventListener("visibilitychange", onVisible); };
    }, []);

    useEffect(() => { fetchMessages(); }, []); //eslint-disable-line

    useEffect(() => {
        const handler = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setShowPopup(false);
        };
        if (showPopup) document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, [showPopup]);

    return (
        <>
            <style>{headerStyles}</style>

            <div className="ish-topbar py-1 px-1 py-md-1 px-md-1 position-relative">
                <div className="container-fluid position-relative">
                    <div className="row align-items-center pt-md-1" style={{ }}>

                        <div className="col-6 col-md-6 mb-2">
                            <img
                                src={logo}
                                alt="Logo"
                                className="ish-logo"
                                style={{ maxWidth: isMobile ? '130px' : '180px' }}
                            />
                        </div>

                        <div className="col-6 col-md-6 mb-2">
                            <div className="ish-controls-group">

                                <div className="ish-username-block d-none d-md-flex">
                                    <span className="ish-username-text">{localStorage.getItem('username')}</span>
                                    <span className="ish-datetime-badge">
                                        {time ? (
                                            <>
                                                {time.toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}
                                                &nbsp;
                                                {time.toLocaleTimeString("en-IN", { hour: "numeric", minute: "numeric", second: "numeric", hour12: true })}
                                            </>
                                        ) : "Loading..."}
                                    </span>
                                </div>

                                <div
                                    className="ish-profile-wrap position-relative"
                                    ref={dropdownRef}
                                    onClick={() => setShowPopup(p => !p)}
                                    aria-haspopup="true"
                                    aria-expanded={showPopup}
                                >
                                    <AccountCircleIcon className="ish-profile-icon" />

                                    {showPopup && (
                                        <div className="ish-profile-dropdown">
                                            <div className="ish-dropdown-item" onClick={(e) => { e.stopPropagation(); changePasswordRef.current?.open(); }}>
                                                <i className="fas fa-key fa-sm fa-fw"></i> Change Password
                                            </div>
                                            <div className="ish-dropdown-divider" />
                                            <div className="ish-dropdown-item" onClick={(e) => { e.stopPropagation(); handleLogout(); }}>
                                                <i className="fas fa-sign-out-alt fa-sm fa-fw"></i> Logout
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div
                                    className="ish-message-wrap"
                                    onMouseEnter={() => setShowMessagesPopup(true)}
                                    onMouseLeave={() => setShowMessagesPopup(false)}
                                >
                                    <MessageIcon className="ish-message-icon" aria-hidden="true" />
                                    {count > 0 && <span className="ish-message-badge">{count}</span>}

                                    {showMessagesPopup && (
                                        <div className={`ish-messages-panel${isMobile ? ' ish-messages-panel' : ''}`}>
                                            <div className="ish-messages-panel-title">Messages</div>
                                            <ul className="ish-messages-list">
                                                {Array.isArray(messages) && messages.length > 0 ? (
                                                    messages.map(item => (
                                                        <li key={item.id} className="ish-message-item">
                                                            <p role="button" onClick={() => {
                                                                setShowMessagesPopup(false);
                                                                handleViewModalOpen(item.id, item.subject, item.message, item.status);
                                                            }}>
                                                                {item.subject?.length > 30 ? item.subject.substring(0, 30) + "…" : item.subject}
                                                                {item.status === "sent" && <span className="ish-badge-new">New</span>}
                                                            </p>
                                                        </li>
                                                    ))
                                                ) : (
                                                    <li className="ish-message-item"><p>You currently have no messages.</p></li>
                                                )}
                                            </ul>
                                        </div>
                                    )}
                                </div>

                                <button
                                    className={`ish-sidebar-toggle-btn d-none d-md-flex ${toggleFullscreen ? 'on' : ''}`}
                                    aria-label={toggleFullscreen ? "Show sidebar" : "Hide sidebar"}
                                    onClick={() => setToggleFullscreen(!toggleFullscreen)}
                                >
                                    <svg className="ish-sidebar-toggle-svg" width="24" height="24" viewBox="-2 -2 28 28" fill="none" strokeWidth="2">
                                        <g className="ish-icon-sidebar-open">
                                            <path stroke="#581f37" d="M 2 9 v -7 h 7" />
                                            <path stroke="#581f37" d="M 22 9 v -7 h -7" />
                                            <path stroke="#581f37" d="M 22 15 v 7 h -7" />
                                            <path stroke="#581f37" d="M 2 15 v 7 h 7" />
                                        </g>
                                        <g className="ish-icon-sidebar-close">
                                            <path stroke="#581f37" d="M 24 17 h -7 v 7" />
                                            <path stroke="#581f37" d="M 0 17 h 7 v 7" />
                                            <path stroke="#581f37" d="M 0 7 h 7 v -7" />
                                            <path stroke="#581f37" d="M 24 7 h -7 v -7" />
                                        </g>
                                    </svg>
                                </button>

                                <button
                                    className="ish-mobile-menu-btn d-flex d-md-none"
                                    onClick={() => setSidebarOpen(v => !v)}
                                    aria-label="Toggle menu"
                                >
                                    {sidebarOpen ? <CloseIcon fontSize="small" /> : <MenuIcon fontSize="small" />}
                                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showModal && (
                <div className="modal fade bd-example-modal-lg show d-block" style={{ backgroundColor: "#7a787878" }} tabIndex="-1" role="dialog" aria-labelledby="ishNotificationModal">
                    <div className="modal-dialog modal-lg" style={{ textAlign: "-webkit-center" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title" id="ishNotificationModal" style={{ color: '#000' }}>{notiSubject}</h4>
                                <button className="btn-close py-0" type="button" aria-label="Close" onClick={handleModalClose} />
                            </div>
                            <div className="modal-body ish-modal-body">
                                <div className="ish-modal-icon-wrap"><i data-feather="chevrons-right"></i></div>
                                <p className="ish-modal-text">{notiMessage}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <ISChangePassword ref={changePasswordRef} />
        </>
    );
}

export default Header;